import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'
import App from './App.vue'
Vue.config.productionTip = false;                       //生产版本默认为false
 Vue.config.devtools = true;                         // 是否检测代码 开发版本默认为 true，生产版本默认为 false
Vue.use(ElementUI)



// VueHighcharts
import VueHighcharts from 'vue-highcharts';
import Highcharts from 'highcharts/highstock';
Vue.use(VueHighcharts, { Highcharts });



import router from './router'                       //路由配置文件vue-router

//import config from './config/httpRequestConfig'     //请求资源路径配置 $Ajax

import GlobalApi from './utils/global'
// VueBus
import VueBus from 'vue-bus';
Vue.use(VueBus);
Vue.use(GlobalApi)

new Vue({
  el: '#app', router,
  render: h => h(App)

})



// WEBPACK FOOTER //
// ./src/main.js